import AdminRoleByScope from "../../models/AdminRoleByScope";

import type {
  AdminRoleScope,
  AdminRoleScopeConfig,
} from "./adminRoleScopes.types";

export const ADMIN_ROLE_SCOPES: Record<AdminRoleScope, AdminRoleScopeConfig> = {
  organization: {
    titleKey: "orgaAccessRights",
    headerKey: "organization",
    allowedRoles: AdminRoleByScope.organizationRoles,
    getScopes: (roles) => roles.organizationList,
    coversAll: (roles) => roles.isOwner,
    // Une seule organisation : un rôle de plus se fait en modifiant le sien.
    canAdd: (roles) => roles.organizationList.length === 0,
    toScopeIds: (uuid) => ({ organizationId: uuid }),
  },
  project: {
    titleKey: "projectAccessRights",
    headerKey: "projects",
    allowedRoles: AdminRoleByScope.basicRoles,
    getScopes: (roles) => roles.projectList,
    coversAll: (roles) => roles.isAdminOrOwner,
    canAdd: (roles) => !roles.isAdminOrOwner,
    toScopeIds: (uuid) => ({ projectId: uuid }),
  },
  channel: {
    titleKey: "fastAccessRights",
    headerKey: "channels",
    allowedRoles: AdminRoleByScope.fastChannelRoles,
    getScopes: (roles) => roles.channelList,
    coversAll: (roles) => roles.isAdminOrOwner,
    canAdd: (roles) => !roles.isAdminOrOwner,
    toScopeIds: (uuid) => ({ channelId: uuid }),
  },
};
